import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { getActiveChartTypeOption } from '@/components/Editor/Form/fields/ChartType/utils';
import GeneralRevealPill from '@/components/Editor/Form/fields/GeneralRevealPill';
import { CHART_TYPES } from '../fields/settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChartStackedBarIcon = function ChartStackedBarIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7650_11007)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.2 9.5C0.537258 9.5 0 10.0317 0 10.6875V17.8125C0 18.4683 0.537258 19 1.2 19C1.86274 19 2.4 18.4683 2.4 17.8125V10.6875C2.4 10.0317 1.86274 9.5 1.2 9.5ZM8.4 11.875C7.73726 11.875 7.2 12.4067 7.2 13.0625V17.8125C7.2 18.4683 7.73726 19 8.4 19C9.06274 19 9.6 18.4683 9.6 17.8125V13.0625C9.6 12.4067 9.06274 11.875 8.4 11.875ZM14.4 10.6875C14.4 10.0317 14.9373 9.5 15.6 9.5C16.2627 9.5 16.8 10.0317 16.8 10.6875V17.8125C16.8 18.4683 16.2627 19 15.6 19C14.9373 19 14.4 18.4683 14.4 17.8125V10.6875ZM22.8 11.875C22.1373 11.875 21.6 12.4067 21.6 13.0625V17.8125C21.6 18.4683 22.1373 19 22.8 19C23.4627 19 24 18.4683 24 17.8125V13.0625C24 12.4067 23.4627 11.875 22.8 11.875Z",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.2 0C0.537258 0 0 0.531662 0 1.1875V5.9375C0 6.59334 0.537258 7.125 1.2 7.125C1.86274 7.125 2.4 6.59334 2.4 5.9375V1.1875C2.4 0.531662 1.86274 0 1.2 0ZM8.4 0C7.73726 0 7.2 0.531662 7.2 1.1875V8.3125C7.2 8.96834 7.73726 9.5 8.4 9.5C9.06274 9.5 9.6 8.96834 9.6 8.3125V1.1875C9.6 0.531662 9.06274 0 8.4 0ZM14.4 1.1875C14.4 0.531662 14.9373 0 15.6 0C16.2627 0 16.8 0.531662 16.8 1.1875V5.9375C16.8 6.59334 16.2627 7.125 15.6 7.125C14.9373 7.125 14.4 6.59334 14.4 5.9375V1.1875ZM22.8 0C22.1373 0 21.6 0.531662 21.6 1.1875V8.3125C21.6 8.96834 22.1373 9.5 22.8 9.5C23.4627 9.5 24 8.96834 24 8.3125V1.1875C24 0.531662 23.4627 0 22.8 0Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7650_11007",
        children: /*#__PURE__*/_jsx("rect", {
          width: "24",
          height: "19",
          fill: "white"
        })
      })
    })]
  }));
};

ChartStackedBarIcon.defaultProps = {
  width: "24",
  height: "19",
  viewBox: "0 0 24 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetEditFormBarChartBaseFields = _ref => {
  let {
    config,
    title,
    component,
    pillVariant,
    onChartSelect
  } = _ref;
  const currentChartType = config.chartType || 'vertical';
  const {
    currentChartTypeOption
  } = getActiveChartTypeOption(currentChartType, CHART_TYPES);
  return /*#__PURE__*/_jsx(GeneralRevealPill, {
    title: title ?? 'Bar Chart',
    leftIcon: component === 'StackedBarChart' ? /*#__PURE__*/_jsx(ChartStackedBarIcon, {}) : currentChartTypeOption === null || currentChartTypeOption === void 0 ? void 0 : currentChartTypeOption.icon,
    pillVariant: pillVariant,
    onChartSelect: onChartSelect
  });
};

export default WidgetEditFormBarChartBaseFields;